import { TabContext, TabList, TabPanel } from "@mui/lab";
import {
    Box,
    Card,
    CardMedia,
    Grid,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Typography,
    useMediaQuery
} from "@mui/material";
import React, { useEffect, useState } from "react";
import GaugeComponent from "react-gauge-component";
import { useNavigate, useParams } from "react-router";
import HomeworkBackground from "../assets/Homework- web.svg";
import InstructionsBackgroundMobile from "../assets/Instructions- Mobile-02.svg";
import InstructionsBackground from "../assets/Instructions- Web.svg";
import HomeworkBackgroundMobile from "../assets/Start you homework-mobile-02.svg";
// import testBackground from "../assets/red_triangular_shape_and_line_pattern_background.jpg";
// import testBackground from "../assets/Dashboard- Web-01.svg";
import testBackground from "../assets/stacked-waves-haikei.svg";
import axiosInstance from "../common/services/axiosInstance";
import { useCharactersContext } from "../hooks/Context";

interface Lesson {
  examId: number;
  classId: number;
  name: string;

  examinationId: {
    examinationId: number;
  };
  subjectId: number;
}

interface QuestionData {
  examId: number;
  active: boolean;
  name: string;
  classId: number;
}

interface ActiveQuestionPaper {
  [key: number]: { name: string; active: boolean; classId: number };
}

const Dashboard = () => {
  const [value, setValue] = useState<string>("1");
  const navigate = useNavigate();
  console.log("Dashboard");
  const isMobile = useMediaQuery("(max-width: 600px)");
  const isTablet = useMediaQuery("(max-width: 820px)");
  const { moduleId, levelId } = useParams();
  const [examParticipation, setExamParticipation] = useState<any[]>([]);
  const [scoredPercentage, setScoredPercentage] = useState<number>(0);
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const [gaugeHeading, setGaugeHeading] = useState<string>();
  const [lessons, setLessons] = useState<Lesson[]>([]);
  const { studentName, studentId, orgId, gaugeValue, setGaugeValue, setStudentLevel } =
    useCharactersContext();
  const [orgName, setOrgName] = useState(null);
  const [orgCode, setOrgCode] = useState(null);
  const [referenceId] = useState(null);
  const [studentCode, setStudentCode] = useState(null);
  const [completedLessons, setCompletedLessons] = useState(0);

  const [activeQuestionPaper, setActiveQuestionPaper] = useState<{
    [key: number]: { name: string; active: boolean; classId: number };
  }>(() => ({}));

  const [activeQuestionData, setActiveQuestionData] = useState<QuestionData[]>(
    []
  );
  const [currentStudentLevel, setCurrentStudentLevel] = useState<number>();
  const [displayedLessons, setDisplayedLessons] = useState<string[]>([]);
  const [displayedHeading, setDisplayedHeading] = useState<string>("");
  const [upcomingLessons, setUpcomingLessons] = useState<
    { examId: number; name: string }[]
  >([]);
  const [pendingExamIds, setPendingExamIds] = useState<number[]>([]);
  const [completedExamIds, setCompletedExamIds] = useState<number[]>([]);

  useEffect(() => {
    axiosInstance
      .get(`/api/master/studentReg/list`, {
        params: {
          studentId: studentId,
        },
      })
      .then((response) => {
        const studentList = response.data.responseData;
        if (studentList.length > 0) {
          setStudentCode(studentList[0].referenceId);
          setStudentLevel(studentList[0].currentLevel)
        } else {
          console.warn("No student found with studentId:", studentId);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [studentId]);

  useEffect(() => {
    axiosInstance
      .get(`/api/master/org/list`, {
        params: { orgId },
      })
      .then((response) => {
        const orgObject = response.data.responseData[0];
        const orgName = orgObject ? orgObject.name : null;
        const orgCode = orgObject ? orgObject.orgCode : null;

        setOrgName(orgName);
        setOrgCode(orgCode);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [orgId]);

  //ActiveQuestionPaper and completedLessons
  useEffect(() => {
    if (!currentStudentLevel) return;
    axiosInstance
      .get("/api/question/questionPaper/list", {
        params: {
          classId: currentStudentLevel,
          active: true,
        },
      })
      .then((response) => {
        console.log("responseactive  ok", response);

        if (Array.isArray(response.data.responseData)) {
          const allQuestionData: QuestionData[] = response.data.responseData;

          console.log("allQuestionData", allQuestionData);

          // Create a mapping between examId and an object with name and active status
          const activeQuestionPaperMap: {
            [key: number]: { name: string; active: boolean; classId: number };
          } = {};

          allQuestionData.forEach((question) => {
            activeQuestionPaperMap[question.examId] = {
              name: question.name,
              active: question.active,
              classId: question.classId,
            };
          });

          setActiveQuestionData(allQuestionData);
          // console.log("activeQuestionPaper", activeQuestionPaper);

          const studentLevelId: number = currentStudentLevel || 0;
          //console.log("studentLevelId ", studentLevelId);

          // Filter values based on classId matching studentLevelId
          const filteredActiveQuestionPaper: ActiveQuestionPaper =
            Object.fromEntries(
              Object.entries(activeQuestionPaperMap).filter(
                ([examId, { classId }]) => classId === studentLevelId
              )
            );

          setActiveQuestionPaper(filteredActiveQuestionPaper);
        } else {
          console.error("Failed to get questionPaper list");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [levelId, currentStudentLevel]);

  useEffect(() => {
    if (currentStudentLevel){
      axiosInstance
        .get(`/api/examinationParticipation/exam/get`, {
          params: {
            classId: currentStudentLevel,
          },
        })
        .then((response) => {
          setLessons(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [levelId, currentStudentLevel]);

  useEffect(() => {
    axiosInstance
      .get("/api/examinationParticipation/examParticipation/get", {
        params: { studentId },
      })
      .then((response) => {


        const examParticipations = response.data;

        // Find the maximum examId for the current student
        const maxExamId = Math.max(
          ...examParticipations.map((item: any) => item.examId),
          0
        );
        setExamParticipation(examParticipations);
        setGaugeValue(maxExamId);
      })

      .catch((error: any) => {
        console.log(error);
      });
  }, [studentId]);

  useEffect(() => {
    setCompletedExamIds(
      examParticipation
        .filter(
          (exam: { examStatus: string }) => exam.examStatus === "completed"
        )
        .map((exam: { examId: any }) => exam.examId)
    );
  }, [examParticipation]);

  useEffect(() => {
    setPendingExamIds(
      Object.entries(activeQuestionPaper)
        .filter(([examId, examData]) => {
          return (
            !completedExamIds.includes(Number(examId)) &&
            examData.active !== false
          );
        })
        .map(([examId]) => Number(examId))
    );
  }, [completedExamIds, activeQuestionPaper, lessons]);

  useEffect(() => {
    setUpcomingLessons(
      lessons
        .filter((lesson: { examId: any }) => {
          const lessonExamId = lesson.examId;
          return (
            !completedExamIds.includes(lessonExamId) &&
            !pendingExamIds.includes(lessonExamId)
          );
        })
        .map((lesson: { examId: any; name: any }) => ({
          examId: lesson.examId,
          name: lesson.name,
        }))
    );
  }, [completedExamIds, pendingExamIds, lessons, currentStudentLevel]);

  console.log("upcomingLessons", upcomingLessons);
  const firstUpcomingLesson = upcomingLessons[0];
  console.log(firstUpcomingLesson, "firstUpcomingLesson");

  useEffect(() => {
    if (gaugeHeading !== undefined) {
      setCurrentStudentLevel(
        parseInt(gaugeHeading.match(/\d+/)?.[0] || "0", 10)
      );
      // console.log("currentStudentLevel", currentStudentLevel);
    } else {
      console.log("gaugeHeading is undefined");
    }
  }, [gaugeHeading, completedExamIds, pendingExamIds, upcomingLessons]);

  //gauge info
  useEffect(() => {
    if (examParticipation.length > 0) {
      // Use reduce to find the object with the maximum classId and examinationId
      const latestExamParticipation = examParticipation.reduce(
        (
          max: { classId: number; examinationId: number },
          current: { classId: number; examinationId: number }
        ) => {
          // Compare classId and examinationId
          if (
            current.classId > max.classId ||
            (current.classId === max.classId &&
              current.examinationId > max.examinationId)
          ) {
            return current;
          } else {
            return max;
          }
        },
        examParticipation[0]
      );

      const { classId, examinationId } = latestExamParticipation;

      console.log("latestExamParticipation", latestExamParticipation);

      axiosInstance
        .get(
          `/api/examinationParticipation/examParticipation/scoredPercentage/${classId}/${examinationId}/${studentId}`
        )
        .then((response) => {
          console.log("responseData", response.data);
          const responseData = response.data;
          setGaugeHeading(responseData.completedLessons.moduleLevelName);
          setScoredPercentage(responseData.scoredPercentage);
          console.log("responseDataScore", responseData);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [examParticipation, studentId]);

  useEffect(() => {
    const pendingExamNames = pendingExamIds.map((examId: number) => {
      const fullLessonName = activeQuestionPaper[examId].name;
      const lessonWithoutHomework = fullLessonName.replace(" Homework", "");
      const formattedLessonName = lessonWithoutHomework
        .toLowerCase()
        .replace(/\b\w/g, (match: string) => match.toUpperCase());

      return formattedLessonName;
    });

    console.log("upcomingLessons", upcomingLessons);

    if (pendingExamNames.length > 0) {
      setDisplayedLessons(pendingExamNames);
      setDisplayedHeading("Pending Lessons");
      console.log("Pending Lessons", pendingExamNames);
    } else if (pendingExamNames.length === 0) {
      setDisplayedLessons(["No Pending Lessons"]);
      setDisplayedHeading("Pending Lessons");
      // } else if (completedLessons === lessons.length) {
      //   setDisplayedLessons(["Excellent!📚"]);
      //   setDisplayedHeading("Completed " + gaugeHeading);
    } else {
      setDisplayedLessons([]);
      setDisplayedHeading("");
    }
  }, [completedExamIds, pendingExamIds, upcomingLessons, lessons]);


  const extractLessonNumber = (lessonName: string): number => {
    const match = lessonName.match(/\d+/);
    return match ? parseInt(match[0], 10) : 0;
  };
  
  const numLessons: number[] = lessons
  .map((lesson) => extractLessonNumber(lesson.name))
  .sort((a, b) => a - b);

  const additionalColors = [
    "#EA4228",
    "#EA4228",
    "#EA4228",
    "#EA4228",
    "#F5CD19",
    "#F5CD19",
    "#F5CD19",
    "#F5CD19",
    "#F5CD19",
    "#F5CD19",
    "#F5CD19",
    "#00FF00",
    "#00FF00",
    "#00FF00",
  ];

  const subArcs = lessons.map((lesson: { name: any }, index: number) => {
    const limit = numLessons[index] || 0;
    const color =
      index < additionalColors.length ? additionalColors[index] : "#F5CD19";

    return {
      limit,
      color,
      showTick: true,
      // tooltip: {
      //   text: lesson.name,
      // },
    };
  });

  useEffect(() => {
    const completedLessons =
      typeof examParticipation.length === "number"
        ? examParticipation.length
        : 0;
    setCompletedLessons(completedLessons);
  }, [examParticipation, pendingExamIds]);

  const lessonLength = lessons.length;
  const lessonIndex =
  lessonLength > 0
    ? ((gaugeValue - 1) % lessonLength)
    : 0;

  // useEffect(() => {
  //   console.log("minValue:", minValue);
  //   console.log("maxValue:", maxValue);
  // }, [minValue, maxValue]);
  const lessonNameAtIndex = lessons[lessonIndex]?.name || "";
  const currentLessonNumber = extractLessonNumber(lessonNameAtIndex);

  return (
    <>
      <TabContext value={value}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            width: "100%",
          }}
        >
          <TabList
            aria-label="Tabs example"
            onChange={handleChange}
            textColor="secondary"
            indicatorColor="secondary"
            centered
            variant="fullWidth"
            scrollButtons="auto"
            TabIndicatorProps={{
              style: {
                backgroundColor: "#F25E6B",
              },
            }}
          >
            <Tab label="Dashboard" value="1" iconPosition="start" />
            <Tab label="Homework" value="2" />
          </TabList>
        </Box>
        <TabPanel value="1">
          <Grid
            item
            container
            justifyContent="center"
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{
              height: isMobile ? "210vh" : "130vh",
              backgroundImage: `url(${testBackground})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
            }}
          >
            <Typography>
              <Box
                sx={{
                  width: isMobile || isTablet ? "80vw" : "80vw",
                  backgroundColor: "white",
                  margin: "5vh",
                  marginLeft: "auto",
                  marginRight: "auto",
                  padding: "2vh",
                  paddingTop: "2vh ",
                  borderRadius: "5vh",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#245CA6",
                    color: "white",
                    textAlign: "center",
                    padding: "2vh",
                    paddingTop: "2vh ",
                    borderRadius: "2vh",
                    // margin: "1vh",
                    fontSize: "20px",
                  }}
                >
                  STUDENT INFORMATION
                </div>
                <TableContainer>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell align="center">
                          <span style={{ fontSize: "16px" }}>Student Name</span>
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: "16px" }}>
                          {studentName}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell align="center">
                          <span style={{ fontSize: "16px" }}>Student Code</span>
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: "16px" }}>
                          {studentCode}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell align="center">
                          <span style={{ fontSize: "16px" }}>Centre Name</span>
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: "16px" }}>
                          {orgName}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell align="center">
                          <span style={{ fontSize: "16px " }}>Centre Code</span>
                        </TableCell>
                        <TableCell align="center" style={{ fontSize: "16px" }}>
                          {orgCode}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>

              {/* {GAUGE STARED } */}
              {completedLessons > 0 ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: isMobile ? "column" : "row",
                    gap: isTablet ? "10px" : "90px",
                    //marginTop: isMobile ? "0vh" : "0vh",
                  }}
                >
                  <Box
                    sx={{
                      width: isMobile ? "80vw" : isTablet ? "35vw" : "20vw",
                      backgroundColor: "white",
                      margin: "1vh",
                      marginLeft: "auto",
                      marginRight: "auto",
                      padding: "2vh",
                      paddingTop: "2vh ",
                      borderRadius: "5vh",
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: "#245CA6",
                        color: "white",
                        textAlign: "center",
                        padding: "2vh",
                        paddingTop: "2vh",
                        borderRadius: "2vh",
                        //margin: "1vh",
                        fontSize: "20px",
                        //maxWidth: "100%",
                        // width: "100%",
                      }}
                    >
                      Homework Progress <br /> {gaugeHeading}
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginLeft: "auto",
                        marginRight: "auto",
                        // width: "100px",
                        // height: "100px",
                        // maxWidth: "100%",
                        width: "100%",
                        paddingTop: "3vh",
                      }}
                    >
                      <GaugeComponent
                        key={`gauge-${currentLessonNumber}-${numLessons.length}`}
                        type="radial"
                        arc={{
                          width: 0.3,
                          padding: 0.001,
                          cornerRadius: 1,
                          subArcs,
                        }}
                        pointer={{
                          color: "#345243",
                          length: 0.8,
                          width: 15,
                        }}
                        labels={{
                          valueLabel: {
                            formatTextValue: () => {return lessons[lessonIndex]?.name || "N/A";},
                            style: {
                              fill: "#151414",
                              textShadow: "none",
                            },
                          },
                          tickLabels: {
                            type: "outer",
                            ticks: subArcs.map((_, index) => {
                              const lessonNumber = extractLessonNumber(lessons[index]?.name || "");
                              return { value: lessonNumber, label: lessonNumber.toString() || "N/A" };
                            }),
                          },
                        }}
                        value={currentLessonNumber}
                        minValue={numLessons[0]}
                        maxValue={Math.max(...numLessons)}
                      />
                    </div>
                  </Box>

                  {/* {2nd box for pending lessons} */}

                  <Box
                    sx={{
                      width: isMobile ? "80vw" : isTablet ? "35vw" : "20vw",
                      backgroundColor: "white",
                      margin: "1vh",
                      marginLeft: "auto",
                      marginRight: "auto",
                      padding: "2vh",
                      paddingTop: "2vh ",
                      borderRadius: "5vh",
                      // overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: "#245CA6",
                        color: "white",
                        textAlign: "center",
                        padding: "2vh",
                        paddingTop: "2vh",
                        borderRadius: "2vh",
                        //margin: "1vh 000",
                        fontSize: "20px",
                      }}
                    >
                      {displayedHeading}
                    </div>
                    <div>
                      <div
                        className="lesson-container"
                        style={{
                          backgroundColor: "#d3eaf2",
                          padding: "4vh",
                          paddingTop: "2vh",
                          borderRadius: "2vh",
                          height: isMobile
                            ? "100%"
                            : isTablet
                            ? "50vh"
                            : "50vh",
                          marginTop: "2vh",
                          overflow: "auto",
                          maxHeight: "250px",
                          transition: "max-height 0.5s ease",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <ul
                          className="lesson-list"
                          style={{
                            borderRadius: "5px",
                            marginRight: "0px",
                            listStyle: "none",
                            flexWrap: "wrap",
                            padding: "0",
                            //paddingTop: "vh",
                          }}
                        >
                          {displayedLessons.map((lesson, index) => (
                            <li
                              className="lesson-li"
                              key={index}
                              style={{
                                backgroundColor: "#E12027",
                                color: "white",
                                padding: "8px",
                                marginBottom: "5px",
                                borderRadius: "3px",
                                boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
                                width: isMobile ? "50vw" : "15vw",
                                height: "4vh",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                textAlign: "center",
                              }}
                            >
                              {lesson}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </Box>

                  {/* 3rd box */}
                  {!isTablet && (
                    <Box
                      sx={{
                        width: isMobile ? "80vw" : isTablet ? "35vw" : "20vw",
                        backgroundColor: "white",
                        margin: "1vh",
                        marginLeft: "auto",
                        marginRight: "auto",
                        padding: "2vh",
                        paddingTop: "2vh",
                        borderRadius: "5vh",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#245CA6",
                          color: "white",
                          textAlign: "center",
                          padding: "2vh",
                          paddingTop: "2vh",
                          borderRadius: "2vh",
                          // marginTop: "4vh 000",
                          fontSize: "20px",
                        }}
                      >
                        Upcoming Lesson
                      </div>

                      <div
                        className="lesson-container"
                        style={{
                          backgroundColor: "#d3eaf2",
                          padding: "4vh",
                          paddingTop: "2vh",
                          borderRadius: "2vh",
                          height: isMobile
                            ? "100%"
                            : isTablet
                            ? "50vh"
                            : "50vh",
                          marginTop: "2vh",
                          overflow: "auto",
                          maxHeight: "250px",
                          transition: "max-height 0.5s ease",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <ul
                          className="lesson-list"
                          style={{
                            borderRadius: "5px",
                            marginRight: "0px",
                            listStyle: "none",
                            flexWrap: "wrap",
                            padding: 0,
                          }}
                        >
                          {upcomingLessons.length === 0 ? (
                            <li
                              className="lesson-li"
                              style={{
                                backgroundColor: "#E12027",
                                color: "white",
                                padding: "8px",
                                marginBottom: "5px",
                                borderRadius: "3px",
                                boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
                                width: isMobile ? "50vw" : "15vw",
                                height: "4vh",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                textAlign: "center",
                              }}
                            >
                              No Upcoming Lesson
                            </li>
                          ) : (
                            // upcomingLessons.map((lesson, index) => (
                            <li
                              className="lesson-li"
                              // key={index}
                              style={{
                                backgroundColor: "#E12027",
                                color: "white",
                                padding: "8px",
                                marginBottom: "5px",
                                borderRadius: "3px",
                                boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
                                width: isMobile ? "50vw" : "15vw",
                                height: "4vh",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                textAlign: "center",
                              }}
                            >
                              {firstUpcomingLesson.name}
                            </li>
                            // ))
                          )}
                        </ul>
                      </div>
                    </Box>
                  )}
                </div>
              ) : (
                ""
              )}
              {/* {GAUGE ENDED } */}

              {/* 3rd box for tab*/}
              {completedLessons > 0 ? (
                <div>
                  {isTablet && (
                    <Box
                      sx={{
                        width: isMobile ? "80vw" : isTablet ? "35vw" : "20vw",
                        backgroundColor: "white",
                        margin: "1vh",
                        marginLeft: "auto",
                        marginRight: "auto",
                        padding: "2vh",
                        paddingTop: "2vh",
                        borderRadius: "5vh",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#245CA6",
                          color: "white",
                          textAlign: "center",
                          padding: "2vh",
                          paddingTop: "2vh",
                          borderRadius: "2vh",
                          // margin: "1vh 000",
                          //marginTop: "4vh 000",
                          fontSize: "20px",
                        }}
                      >
                        Upcoming Lesson
                      </div>

                      <div
                        className="lesson-container"
                        style={{
                          backgroundColor: "#d3eaf2",
                          padding: "4vh",
                          paddingTop: "2vh",
                          borderRadius: "2vh",
                          height: isMobile || isTablet ? "100%" : "50vh",
                          marginTop: "2vh",
                          overflow: "auto",
                          maxHeight: "250px",
                          transition: "max-height 0.5s ease",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <ul
                          className="lesson-list"
                          style={{
                            borderRadius: "5px",
                            marginRight: "0px",
                            listStyle: "none",
                            flexWrap: "wrap",
                            padding: 0,
                          }}
                        >
                          {" "}
                          {upcomingLessons.length === 0 ? (
                            <li
                              className="lesson-li"
                              style={{
                                backgroundColor: "#E12027",
                                color: "white",
                                padding: "8px",
                                marginBottom: "5px",
                                borderRadius: "3px",
                                boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
                                width: isMobile ? "50vw" : "15vw",
                                height: "4vh",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                textAlign: "center",
                              }}
                            >
                              No Upcoming Lesson
                            </li>
                          ) : (
                            // upcomingLessons.map((lesson, index) => (
                            <li
                              className="lesson-li"
                              // key={index}
                              style={{
                                backgroundColor: "#E12027",
                                color: "white",
                                padding: "8px",
                                marginBottom: "5px",
                                borderRadius: "3px",
                                boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
                                width: isMobile ? "50vw" : "15vw",
                                height: "4vh",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                textAlign: "center",
                              }}
                            >
                              {firstUpcomingLesson.name}
                            </li>
                            //  ))
                          )}
                        </ul>
                      </div>
                    </Box>
                  )}
                </div>
              ) : (
                ""
              )}
              {/* {GAUGE ENDED } */}
            </Typography>
          </Grid>
        </TabPanel>
        <TabPanel value="2">
          <Grid
            item
            container
            justifyContent="center"
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{
              height: "100vh",
              backgroundImage: `url(${testBackground})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
            }}
          >
            <Grid item xs={12} sm={6} justifyContent="center">
              <Card
                variant="outlined"
                sx={{
                  borderRadius: "12px",
                  marginTop: "5vh",
                  marginBottom: "auto",
                  marginLeft: isMobile ? "auto" : "6%",
                  marginRight: isMobile ? "auto" : "3%",
                  boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
                  cursor: "pointer",
                  height: isMobile ? "350px" : "auto",
                  width: isMobile ? "300px" : "auto",
                }}
                onClick={() => navigate("/instructions")}
              >
                <div style={{ position: "relative" }}>
                  <CardMedia
                    image={
                      isMobile || isTablet
                        ? InstructionsBackgroundMobile
                        : InstructionsBackground
                    }
                    component="img"
                    title="Instructions"
                  />
                  <div
                    style={{
                      position: "absolute",
                      color: "white",
                      top: "10.5vh",
                      left: "8%",
                      // transform: isMobile
                      //   ? "translateX(-50%)"
                      //   : "translateX(-95%)",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: isMobile || isTablet ? "3vh" : "8vh",
                        // fontSize: isTablet ? (isMobile ? "3vh" : "8vh") : "7vh",
                        color: "white",
                        fontWeight: "bold",
                        borderBottom: "2px solid red",
                      }}
                    >
                      Instructions
                    </Typography>
                  </div>
                </div>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Card
                variant="outlined"
                sx={{
                  borderRadius: "12px",
                  marginTop: "5vh",
                  marginBottom: "2%",
                  marginLeft: isMobile ? "auto" : "6%",
                  marginRight: isMobile ? "auto" : "3%",
                  boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
                  cursor: "pointer",
                  height: isMobile ? "350px" : "auto",
                  width: isMobile ? "300px" : "auto",
                }}
                onClick={() => navigate("/modules")}
              >
                <div style={{ position: "relative" }}>
                  <CardMedia
                    image={
                      isMobile || isTablet
                        ? HomeworkBackgroundMobile
                        : HomeworkBackground
                    }
                    component="img"
                    title="Start Homework"
                  />
                  <div
                    style={{
                      position: "absolute",
                      color: "white",
                      top: "5vh",
                      left: "10%",
                      // transform: isMobile
                      //   ? "translateX(-50%)"
                      //   : "translateX(-80%)",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: isMobile || isTablet ? "3vh" : "7vh",
                        color: "white",
                        fontWeight: "bold",
                        // textDecoration: "underline",
                        borderBottom: "2px solid red",
                      }}
                    >
                      Click
                      <br />
                      to view all
                      <br />
                      homeworks
                    </Typography>
                  </div>
                </div>
              </Card>
            </Grid>
          </Grid>
        </TabPanel>
      </TabContext>
    </>
  );
};

export default Dashboard;
